export const DEFAULT_SCHOOL_ABREV =
  process.env.REACT_APP_DEFAULT_SCHOOL_ABREV || "ebun";

export const DEFAULT_SCHOOL_WEBSITE =
  process.env.REACT_APP_DEFAULT_SCHOOL_WEBSITE || "www.ebunheritageschool.com";

export const DEFAULT_SCHOOL_LOGO_URL =
  process.env.REACT_APP_DEFAULT_SCHOOL_LOGO_URL ||
  "https://smartedung.com/ebun/logo.png";

export const getSchoolAbrev = (schoolAbrev) =>
  schoolAbrev || DEFAULT_SCHOOL_ABREV;

export const getStudentAppUrl = () =>
  process.env.REACT_APP_STUDENT_APP_URL || "https://app.smartedung.com";
